import { useSortable } from "@dnd-kit/sortable";
import { BarsMenuIcon } from "assets/icons";
import cn from "classnames";

import styles from "../ItemsTableDragDrop.module.scss";

const RowDragHandleCell = ({
  rowId,
  isDragDisabled
}: {
  rowId: string;
  isDragDisabled?: boolean;
}) => {
  const { attributes, listeners } = useSortable({
    id: rowId
  });

  return (
    <div
      {...attributes}
      {...listeners}
      className={cn(styles.table_grab, {
        [styles["table_grab--disabled"]]: isDragDisabled
      })}
    >
      <BarsMenuIcon />
    </div>
  );
};

export default RowDragHandleCell;
